<!-- 侧边栏 -->
<template>
  <div class="hn-sidebar">
    <div class="sidebar-left">
      <div v-for="(item,index) in dataList" :key="index" :style="{background: value===item.id ? 'white' : '#f5f5f5'}" @click="$emit('input',item.id)">
        {{ item.name }}
      </div>
    </div>
    <div class="sidebar-content">
      <slot></slot>
    </div>
  </div>

</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    dataList: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    value() {
      let dom = document.querySelector('.sidebar-content')
      dom.scrollTop = 0
    },
  },
}
</script>

<style lang="less" scoped>
.hn-sidebar {
  display: flex;
}
.sidebar-left {
  width: 100px;
  height: calc(100vh - 100px);
  background: #f5f5f5;
  display: inline-block;
  & > div {
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 14px;
  }
}
.sidebar-content {
  width: calc(100% - 100px);
  height: calc(100vh - 100px);
  display: inline-block;
  overflow-y: auto;
  // background: rebeccapurple;
}
</style>


// WEBPACK FOOTER //
// src/components/common/Sidebar.vue